import axios from "axios";
import React, { useState, useEffect } from "react";
import host from "../host";
import "./Offer.css";
import Spinner from "../Spinner";

function Prereg(props) {
  const [offeredSubject, setOfferedSubject] = useState([]);
  const [selectedTrim, setSelectedTrim] = useState(0);
  const [loadingOffer, setLoadingOffer] = useState(true);

  const student = props.student;
  const trimesters = props.trimesters;

  useEffect(() => {
    loadOffered();
  }, [selectedTrim]);

  const loadOffered = () => {
    setLoadingOffer(true);
    axios
      .post(`${host}loadOfferedSubjects`, {
        idstudent: student.idstudent,
        idsyc: selectedTrim,
      })
      .then((res) => {
        setOfferedSubject(res.data);
        setLoadingOffer(false);
        console.log(res.data);
      });
  };

  return (
    <div className="h-full flex flex-col">
      <div className="offerTitle">
        <h1>Pre-Enrollment Dashboard</h1>
      </div>

      <div className="subjectsOffered">
        <div className="selectTrimester">
          <select
            className="peaci-select w-full max-w-md"
            onChange={(e) => {
              setSelectedTrim(e.target.value);
              console.log(e.target.value);
            }}
            value={selectedTrim}
          >
            <option value="0">Select Trimester</option>
            {trimesters.map((val, key) => {
              return (
                <option value={val.idsyc} key={key}>
                  {val.sy_name}
                </option>
              );
            })}
          </select>
        </div>
      </div>
    </div>
  );
}

export default Prereg;
